<template><div><h1 id="zahlung-erfassen" tabindex="-1"><a class="header-anchor" href="#zahlung-erfassen"><span>Zahlung erfassen</span></a></h1>
<p>Zahlung manuell erfassen — Neue Zahlung in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Bei der Zahlung handelt es sich um eine manuelle Ausgleichsbuchung für einen Auftrag. Die Konto-Kostenstelle-Kostenträger-Informationen werden aus der gewählten Faktura übernommen.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Neue Zahlung (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Zahlung gebucht wird</dd>
<dt>Fakturanummer</dt>
<dd>Auswahl einer bestehenden Fakturamnummer</dd>
<dt>Betrag</dt>
<dd>Zahlungsbetrag (Vorschlag aus Rechnungsbetrag)</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>frei definierbare Zahlungsnummer</dd>
</dl>
<h3 id="auswirkungen-der-zahlungserfassung" tabindex="-1"><a class="header-anchor" href="#auswirkungen-der-zahlungserfassung"><span>Auswirkungen der Zahlungserfassung</span></a></h3>
<p>Beim Erfassen einer Zahlung wird automatisch die erste offene Faktura bei der angezeigten Adresse vorgeschlagen. Falls der Cursor auf einer Position mit offener Faktura steht, wird diese Faktura vorgeschlagen.</p>
<p><strong>Tabelle 70. Mögliche Situationen beim Erfassen einer Zahlung</strong></p>
<table>
<thead>
<tr>
<th>Fakturawährung</th>
<th>Zahlungswährung</th>
<th>Auswirkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Faktura in Landeswährung</td>
<td>Zahlung in Landeswährung</td>
<td>Bei Eingabe der Zahlung muss die Währung des Habenkontos die Landeswährung sein. Die Faktura wird ausgeglichen wenn der eingegebene Betrag gleich oder grösser ist, als der offene Betrag bei der Faktura. Falls der Betrag grösser ist als der &quot;offene Betrag&quot;, wird der Überschuss auf das Guthabenkonto gebucht und in den &quot;manuellen Buchungen&quot; erscheint es als freies Guthaben.</td>
</tr>
<tr>
<td>Faktura in Landeswährung</td>
<td>Zahlung in Fremdwährung</td>
<td>Massgebend für die Zahlungswährung ist die Währung des Habenkontos. In diesem Fall muss beim Erfassen der Zahlung die Währung dem Habenkonto entsprechen. Der Betrag in Landeswährung wird automatisch aus der Fremdwährung mit dem Kurs zum Valutadatum umgerechnet. Weiter verhält sich das System so wie bei einer Zahlung mit Landeswährung.</td>
</tr>
<tr>
<td>Faktura in Fremdwährung</td>
<td>Zahlung in Landeswährung</td>
<td>Massgebend für die Zahlungswährung ist die Währung des Habenkontos. In diesem Fall muss beim Erfassen der Zahlung das Habenkonto in Landeswährung sein. Der Landeswährungsbetrag wird automatisch in die Fremdwährung mit dem Kurs zum Valutadatum umgerechnet. Eine Faktura wird dabei ausgeglichen, wenn der Fremdbetrag gleich oder grösser als die Summe der Fremdwährungsbeträge für diese Fakturanummer ist. Der Betrag, der diese Summe übersteigt, wird als freies Guthaben in der Fremdwährung gebucht. Die Summe der Beträge in Fremdwährung ist bei einer ausgeglichener Faktura gleich Null. Die Summe der Beträge in Landeswährung wird durch eine automatisch erstellte Kurs-Gewinn/Verlust-Buchung ebenfalls auf Null gebracht. Eine sollche Buchung wird nur zu dem Zeitpunkt erstellt, wenn die Faktura in Fremdwährung ausgeglichen wird.</td>
</tr>
<tr>
<td>Faktura in Fremdwährung</td>
<td>Zahlung in Fremdwährung</td>
<td>Massgebend ist die Währung des Habenkontos. In diesem Fall muss beim Erfassen der Zahlung das Habenkonto in der selben Fremdwährung wie die Faktura sein. Der Landeswährungbetrag wird automatisch aus der Fremdwährung mit dem Kurs vom Valutadatum umgerechnet. Eine Faktura wird erst ausgeglichen, wenn die Summe der Zahlungen gleich oder grösser als die Summe der Faktura ist. Der Betrag, der diese Summe übersteigt, wird als freies Guthaben in Fremdwährung gebucht. Die Kursgewinn-/Kursverlust-Buchung wird beim ausgleich der Faktura automatisch erstellt unter den gleichen Bedingungen, wie bei einer Zahlung in Landeswährung.</td>
</tr>
<tr>
<td>keine Fakturanummer bei der Adresse</td>
<td>Zahlung in Landeswährung</td>
<td>Die Zahlung wird auf das Guthabenkonto in der Landeswährung gebucht. Es ensteht ein freies Guthaben.</td>
</tr>
<tr>
<td>keine Fakturanummer bei der Adresse</td>
<td>Zahlung in Fremdwährung</td>
<td>Die Zahlung wird auf das Guthabenkonto in entsprechender Fremdwährung gebucht. Es ensteht ein freies Guthaben.</td>
</tr>
</tbody>
</table>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>keiner</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


